// // import React from "react";

// // const ContactForm = () => {
// //   return (
// //     <section className="bg-[#f9f6f1] py-16 px-4 md:px-10 lg:px-20">
// //       <div className="max-w-5xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100">
// //         <form className="space-y-6">
// //           {/* Name Fields */}
// //           <div className="grid md:grid-cols-2 gap-6">
// //             <div>
// //               <label
// //                 htmlFor="firstName"
// //                 className="block text-sm font-medium text-gray-800 mb-1"
// //               >
// //                 First name
// //               </label>
// //               <input
// //                 id="firstName"
// //                 type="text"
// //                 placeholder="First name"
// //                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
// //               />
// //             </div>
// //             <div>
// //               <label
// //                 htmlFor="lastName"
// //                 className="block text-sm font-medium text-gray-800 mb-1"
// //               >
// //                 Last name
// //               </label>
// //               <input
// //                 id="lastName"
// //                 type="text"
// //                 placeholder="Last name"
// //                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
// //               />
// //             </div>
// //           </div>

// //           {/* Contact Fields */}
// //           <div className="grid md:grid-cols-2 gap-6">
// //             <div>
// //               <label
// //                 htmlFor="phone"
// //                 className="block text-sm font-medium text-gray-800 mb-1"
// //               >
// //                 Phone number
// //               </label>
// //               <input
// //                 id="phone"
// //                 type="tel"
// //                 placeholder="Phone number"
// //                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
// //               />
// //             </div>
// //             <div>
// //               <label
// //                 htmlFor="email"
// //                 className="block text-sm font-medium text-gray-800 mb-1"
// //               >
// //                 Email address
// //               </label>
// //               <input
// //                 id="email"
// //                 type="email"
// //                 placeholder="Email address"
// //                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
// //               />
// //             </div>
// //           </div>

// //           {/* Message Field */}
// //           <div>
// //             <label
// //               htmlFor="message"
// //               className="block text-sm font-medium text-gray-800 mb-1"
// //             >
// //               Enter your message
// //             </label>
// //             <textarea
// //               id="message"
// //               rows="5"
// //               placeholder="Enter your message"
// //               className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300 resize-none"
// //             ></textarea>
// //           </div>

// //           {/* Submit Button */}
// //           <div>
// //             <button
// //               type="submit"
// //               className="bg-[#C08B89] text-white uppercase text-sm font-medium py-3 px-8 rounded-md hover:bg-[#a66e67] transition-all duration-300"
// //             >
// //               Send Message
// //             </button>
// //           </div>
// //         </form>
// //       </div>
// //     </section>
// //   );
// // };

// // export default ContactForm;


// import React, { useRef, useState } from "react";
// import emailjs from "@emailjs/browser";

// const ContactForm = () => {
//   const form = useRef();
//   const [loading, setLoading] = useState(false);
//   const [status, setStatus] = useState("");

//   const sendEmail = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     emailjs
//       .sendForm(
//         "service_i2h82eb", // replace with your EmailJS service ID
//         "template_1a38hyn", // replace with your EmailJS template ID
//         form.current,
//         "hjLXq5MC66R977QFn" // replace with your EmailJS public key
//       )
//       .then(
//         (result) => {
//           console.log(result.text);
//           setStatus("✅ Message sent successfully!");
//           setLoading(false);
//           form.current.reset();
//           setTimeout(() => setStatus(""), 4000);
//         },
//         (error) => {
//           console.error(error.text);
//           setStatus("❌ Failed to send message. Please try again.");
//           setLoading(false);
//           setTimeout(() => setStatus(""), 4000);
//         }
//       );
//   };

//   return (
//     <section className="bg-[#f9f6f1] py-16 px-4 md:px-10 lg:px-20">
//       <div className="max-w-5xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100">
//         <form ref={form} onSubmit={sendEmail} className="space-y-6">
//           {/* Name Fields */}
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label
//                 htmlFor="firstName"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 First name
//               </label>
//               <input
//                 name="first_name"
//                 id="firstName"
//                 type="text"
//                 placeholder="First name"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//             <div>
//               <label
//                 htmlFor="lastName"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 Last name
//               </label>
//               <input
//                 name="last_name"
//                 id="lastName"
//                 type="text"
//                 placeholder="Last name"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//           </div>

//           {/* Contact Fields */}
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label
//                 htmlFor="phone"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 Phone number
//               </label>
//               <input
//                 name="phone"
//                 id="phone"
//                 type="tel"
//                 placeholder="Phone number"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//             <div>
//               <label
//                 htmlFor="email"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 Email address
//               </label>
//               <input
//                 name="email"
//                 id="email"
//                 type="email"
//                 placeholder="Email address"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//           </div>

//           {/* Message Field */}
//           <div>
//             <label
//               htmlFor="message"
//               className="block text-sm font-medium text-gray-800 mb-1"
//             >
//               Enter your message
//             </label>
//             <textarea
//               name="message"
//               id="message"
//               rows="5"
//               placeholder="Enter your message"
//               required
//               className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300 resize-none"
//             ></textarea>
//           </div>

//           {/* Status Message */}
//           {status && (
//             <p
//               className={`text-sm ${
//                 status.startsWith("✅") ? "text-green-600" : "text-red-500"
//               }`}
//             >
//               {status}
//             </p>
//           )}

//           {/* Submit Button */}
//           <div>
//             <button
//               type="submit"
//               disabled={loading}
//               className="bg-[#C08B89] text-white uppercase text-sm font-medium py-3 px-8 rounded-md hover:bg-[#a66e67] transition-all duration-300 disabled:opacity-70"
//             >
//               {loading ? "Sending..." : "Send Message"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default ContactForm;


// import React, { useRef, useState } from "react";
// import emailjs from "@emailjs/browser";

// const ContactForm = () => {
//   const form = useRef();
//   const [loading, setLoading] = useState(false);
//   const [status, setStatus] = useState("");

//   const sendEmail = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     emailjs
//       .sendForm(
//         "service_i2h82eb",
//         "template_1a38hyn",
//         form.current,
//         "hjLXq5MC66R977QFn"
//       )
//       .then(
//         () => {
//           setStatus("✅ Message sent successfully!");
//           setLoading(false);
//           form.current.reset();
//           setTimeout(() => setStatus(""), 4000);
//         },
//         () => {
//           setStatus("❌ Failed to send message. Please try again.");
//           setLoading(false);
//           setTimeout(() => setStatus(""), 4000);
//         }
//       );
//   };

//   return (
//     <section className="bg-[#f9f6f1] py-16 px-4 md:px-10 lg:px-20 font-body">
//       <div className="max-w-5xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100">
//         <h2 className="text-3xl md:text-4xl font-heading text-gray-800 text-center mb-10">
//           Get in Touch
//         </h2>

//         <form ref={form} onSubmit={sendEmail} className="space-y-6">
//           {/* Name Fields */}
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label
//                 htmlFor="firstName"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 First name
//               </label>
//               <input
//                 name="first_name"
//                 id="firstName"
//                 type="text"
//                 placeholder="First name"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//             <div>
//               <label
//                 htmlFor="lastName"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 Last name
//               </label>
//               <input
//                 name="last_name"
//                 id="lastName"
//                 type="text"
//                 placeholder="Last name"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//           </div>

//           {/* Contact Fields */}
//           <div className="grid md:grid-cols-2 gap-6">
//             <div>
//               <label
//                 htmlFor="phone"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 Phone number
//               </label>
//               <input
//                 name="phone"
//                 id="phone"
//                 type="tel"
//                 placeholder="Phone number"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//             <div>
//               <label
//                 htmlFor="email"
//                 className="block text-sm font-medium text-gray-800 mb-1"
//               >
//                 Email address
//               </label>
//               <input
//                 name="email"
//                 id="email"
//                 type="email"
//                 placeholder="Email address"
//                 required
//                 className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
//               />
//             </div>
//           </div>

//           {/* Message Field */}
//           <div>
//             <label
//               htmlFor="message"
//               className="block text-sm font-medium text-gray-800 mb-1"
//             >
//               Enter your message
//             </label>
//             <textarea
//               name="message"
//               id="message"
//               rows="5"
//               placeholder="Enter your message"
//               required
//               className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300 resize-none"
//             ></textarea>
//           </div>

//           {/* Status Message */}
//           {status && (
//             <p
//               className={`text-sm ${
//                 status.startsWith("✅") ? "text-green-600" : "text-red-500"
//               }`}
//             >
//               {status}
//             </p>
//           )}

//           {/* Submit Button */}
//           <div className="text-center">
//             <button
//               type="submit"
//               disabled={loading}
//               className="bg-[#C08B89] text-white uppercase text-sm font-medium py-3 px-8 rounded-md hover:bg-[#a66e67] transition-all duration-300 disabled:opacity-70"
//             >
//               {loading ? "Sending..." : "Send Message"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default ContactForm;


import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    // ✅ Add page URL dynamically before sending
    const pageUrlInput = document.createElement("input");
    pageUrlInput.type = "hidden";
    pageUrlInput.name = "page_url";
    pageUrlInput.value = window.location.href;
    form.current.appendChild(pageUrlInput);

    emailjs
      .sendForm(
        "service_i2h82eb", // ✅ your EmailJS service ID
        "template_1a38hyn", // ✅ your EmailJS template ID
        form.current,
        "hjLXq5MC66R977QFn" // ✅ your EmailJS public key
      )
      .then(
        () => {
          setStatus("✅ Message sent successfully!");
          setLoading(false);
          form.current.reset();
          setTimeout(() => setStatus(""), 4000);
        },
        () => {
          setStatus("❌ Failed to send message. Please try again.");
          setLoading(false);
          setTimeout(() => setStatus(""), 4000);
        }
      );
  };

  return (
    <section className="bg-[#f9f6f1] py-16 px-4 md:px-10 lg:px-20 font-body">
      <div className="max-w-5xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100">
        <h2 className="text-3xl md:text-4xl font-heading text-gray-800 text-center mb-10">
          Get in Touch
        </h2>

        <form ref={form} onSubmit={sendEmail} className="space-y-6">
          {/* Name Fields */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-gray-800 mb-1"
              >
                First name
              </label>
              <input
                name="first_name"
                id="firstName"
                type="text"
                placeholder="First name"
                required
                className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
              />
            </div>
            <div>
              <label
                htmlFor="lastName"
                className="block text-sm font-medium text-gray-800 mb-1"
              >
                Last name
              </label>
              <input
                name="last_name"
                id="lastName"
                type="text"
                placeholder="Last name"
                required
                className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
              />
            </div>
          </div>

          {/* Contact Fields */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-800 mb-1"
              >
                Phone number
              </label>
              <input
                name="phone"
                id="phone"
                type="tel"
                placeholder="Phone number"
                required
                className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-800 mb-1"
              >
                Email address
              </label>
              <input
                name="email"
                id="email"
                type="email"
                placeholder="Email address"
                required
                className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
              />
            </div>
          </div>

          {/* Product Field (Optional) */}
          <div>
            <label
              htmlFor="product"
              className="block text-sm font-medium text-gray-800 mb-1"
            >
              Product (optional)
            </label>
            <input
              name="product"
              id="product"
              type="text"
              placeholder="Enter product name"
              className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300"
            />
          </div>

          {/* Message Field */}
          <div>
            <label
              htmlFor="message"
              className="block text-sm font-medium text-gray-800 mb-1"
            >
              Enter your message
            </label>
            <textarea
              name="message"
              id="message"
              rows="5"
              placeholder="Enter your message"
              required
              className="w-full border border-gray-200 rounded-md p-3 text-sm focus:outline-none focus:ring-1 focus:ring-rose-300 resize-none"
            ></textarea>
          </div>

          {/* Status Message */}
          {status && (
            <p
              className={`text-sm ${
                status.startsWith("✅") ? "text-green-600" : "text-red-500"
              }`}
            >
              {status}
            </p>
          )}

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              disabled={loading}
              className="bg-[#C08B89] text-white uppercase text-sm font-medium py-3 px-8 rounded-md hover:bg-[#a66e67] transition-all duration-300 disabled:opacity-70"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
